import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export class Appraiser{
    firstName!: string;
    lastName!: string;
    email!: string;
    name!: string;
    userType!: string;
}


interface InitialState {
    data: Appraiser[] ,
    error: string,
    loading: boolean
}
const initialState: InitialState =
{
    data: [] as Appraiser[],
    error: '',
    loading: false
}

const appraiser1Slice = createSlice({
    name: "appraiser",
    initialState,
    reducers: {
        setAppraiser1Array(state, action: PayloadAction<Appraiser[]>) {
            state.data = action.payload;
        },
    },
});

export const { setAppraiser1Array } = appraiser1Slice.actions;

export default appraiser1Slice.reducer;